import type { Locale } from '../translations';

import de from './de';
import en from './en';
import es from './es';
import fr from './fr';
import it from './it';
import nl from './nl';
import type { AdminUiCopy } from './types';

export type { AdminUiCopy } from './types';

export const adminUiCopy: Record<Locale, AdminUiCopy> = {
  en,
  de,
  fr,
  es,
  it,
  nl,
};
